import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { TitleService } from "../title.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-chat-title",
  templateUrl: "./chat-title.component.html",
  styleUrls: ["./chat-title.component.css"],
})
export class ChatTitleComponent implements OnInit {
  constructor(
    private titleService: TitleService,
    private route: ActivatedRoute
  ) {}

  @ViewChild("titlefocus", { static: false }) titleInput: ElementRef;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.selected_conversation_id = params["conversation_id"] || "";
    });
    this.newTitle = this.title || "Untitled chat";
  }

  @Input() subscription_id: string;
  @Input() conversation_id: string;
  @Input() title: string;
  selected_conversation_id: string;
  newTitle: string;
  editMode: boolean = false;
  deleteMode: boolean = false;
  @Output() newChatDeletionEvent = new EventEmitter<string>();

  deleteChat(event: MouseEvent): void {
    event.preventDefault();
    this.newChatDeletionEvent.emit(this.conversation_id);
  }

  updateTitle(): void {
    if (this.newTitle !== this.title) {
      this.titleService
        .updateTitle(this.subscription_id, this.conversation_id, this.newTitle)
        .subscribe();
    }
    this.title = this.newTitle;
    this.editMode = false;
  }

  cancelEdit(event: MouseEvent): void {
    this.editMode = false;
    this.newTitle = this.title;
    event.preventDefault();
  }

  cancelDelete(event: MouseEvent): void {
    this.deleteMode = false;
    event.preventDefault();
  }

  startEditMode(event: MouseEvent): void {
    setTimeout(() => {
      this.titleInput.nativeElement.focus();
    }, 0);
    this.newTitle = this.title;
    this.editMode = true;
    event.preventDefault();
  }

  startDeleteMode(event: MouseEvent): void {
    this.newTitle = this.title;
    this.deleteMode = true;
    event.preventDefault();
  }
}
